export const INTERNSHIPS_MANAGER = {
  SET_REFUSED_INTERNSHIP: 'SET_REFUSED_INTERNSHIP'
}
